export const UPDATE_FEEDBACK_SURVEY_ENABLED = 'UPDATE_FEEDBACK_SURVEY_ENABLED';